// extracted by mini-css-extract-plugin
export default {"ExchangersPopup":"ExchangersPopup_ExchangersPopup__ATCcu"};